import {
  createContext,
  useContext,
  useMemo,
  useState,
  Dispatch,
  SetStateAction,
  PropsWithChildren
} from 'react'

export enum Step {
  ConfirmEditingStep,
  UploadIdDocumentStep,
  OcrFailedStep,
  OcrSucceededStep,
  AddSSNStep,
  EditManuallyStep,
  AddWorkPermitStep
}

interface StepsContextValue {
  step: Step
  setStep: Dispatch<SetStateAction<Step>>
}

const StepContext = createContext<StepsContextValue>({
  step: Step.ConfirmEditingStep,
  setStep: () => {}
})

export function useStep() {
  return useContext(StepContext)
}

export const StepProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [currentStep, setCurrentStep] = useState<Step>(Step.ConfirmEditingStep)

  const context = useMemo(
    (): StepsContextValue => ({ step: currentStep, setStep: setCurrentStep }),
    [currentStep]
  )

  return <StepContext.Provider value={context}>{children}</StepContext.Provider>
}
